/**
 * Created by fajar on 01/26/2018.
 *
 * Entity for user property with extending BaseEntity
 * and rule logic for serialize (wrapping) and
 * deserialize (explain) property
 */

import { deserialize, serialize, inheritSerialization } from 'cerialize';
import Authentication from "../Authentication";

import BaseEntity from './BaseEntity';
import TableColumn from './TableColumn';
import { getVm } from '../util/GlobalVm';

@inheritSerialization(BaseEntity)
export default class User extends BaseEntity {

    @serialize
    @deserialize
    public username: string = '';

    @serialize
    @deserialize
    public name: string = '';

    @serialize
    @deserialize
    public email: string = '';

    @serialize
    @deserialize
    public nip: number = 0;

    @serialize
    @deserialize
    public age: number = 0;

    @serialize
    @deserialize
    public password: string = '';

    @deserialize
    public confirmPassword: string = '';

    @deserialize
    public oldPassword: string = '';

    @deserialize
    public token: string = '';

    @serialize
    @deserialize
    public profileImage: string = '';

    @serialize
    @deserialize
    public profile: string = '';

    @serialize
    @deserialize
    public phone: string = '';

    @serialize
    @deserialize
    public roles: Array<string> = [];

    @serialize
    @deserialize
    public merchant: any = null;

    public file: any = null;

    public teleponFeedback() {
        return this.defaultPropertyFeedback('phone');
    }

    public emailFeedback() {
        return this.defaultPropertyFeedback('email');
    }

    public profileFeedback() {
        return this.defaultPropertyFeedback('profile');
    }

    public confirmPasswordFeedback() {
        const { password, confirmPassword } = this;
        const valid: boolean = password === confirmPassword;
        const message: any = valid ? '' : getVm().$t('text.invalid_conf_pwd');

        return this.defaultPropertyFeedback('confirmPassword', valid, message);
    }

    public usernameFeedback() {
        const { username } = this;
        const valid = username.length > 4;
        const type = valid ? 'success' : 'danger';
        const message = valid ? '' : getVm().$t('text.min_length', { field: 'Username', count: 5 });

        return { valid, type, message };
    }

    public passwordFeedback() {
        const { password } = this;
        const valid = password.length > 4;
        const type = valid ? 'success' : 'danger';
        const message = valid ? '' : getVm().$t('text.min_length', { field: 'Password', count: 5 });

        return { valid, type, message };
    }

    public loginFeedback() {
        const valid = this.passwordFeedback().valid && this.usernameFeedback().valid;
        const message = valid ? '' : getVm().$t('text.some_input_not_valid');
        const type = valid ? 'info' : 'danger';

        return { valid, message, type };
    }

    public table(): any {
        const { username, profile, roles, email, phone } = this;
        const role = roles[0]
        return { username, profile, role, email, phone };
    }

    public static columnName(): Array<TableColumn> {
        const user = new User().table();
        let keys = Object.keys(user);

        return keys.map((field: any) => {
            const tableColumn = new TableColumn();
            tableColumn.name = getVm().$t(`label.${field}`);

            return tableColumn;
        });
    }

    public get userUserName() {
        return this.username;
    }

    public get superAdmin() {
        const role = this.roles[0];
        return role == "ADMIN" || role == 'TELLER' || role == 'BENDAHARA_PUSAT' || role == 'MASYAYIKH';
    }

    public get isBendaharaPusat() {
        return this.roles[0] == "BENDAHARA_PUSAT";
    }

    public static OnSerialized(instance: User, json: any): void {
        if (parseInt(json.id) === 0) {
            const user: any = Authentication.getUser();
            const valid: boolean = !(user === 'undefined' ||
                typeof user === 'undefined' ||
                typeof user === 'string') &&
                typeof user === 'object' &&
                typeof user.token === 'string' &&
                Object.keys(user).length !== 0;

            if (valid) {
                json.id = user.id
            }
        } else if (parseInt(json.id) === 0) {
            delete json.id;
        }

    }
}
